import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Box from "components/common/Box";
import Text from "components/common/Text";
import MenuItem from "components/common/MenuItem";
import Select from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "components/common/Button";
import Stack from "components/common/Stack";
import TextField from "components/common/TextField";
import { Formik } from "formik";
import * as yup from "yup";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Switch from "../../common/Switch";
import CTable from "components/common/Table";
import { Typography } from "@mui/material";

const AddVehicleModel = ({
  data,
  submitVehicle,
  onClickEdit,
  handleStatusVehicle,
  selectlist,
  handleOnChnageVehicle,
  loading,
  vehicleModelType
}) => {
  const [selectedManufacturer, setSelectedManufacturer] = React.useState("");
  const [selectedVehicleType, setSelectedVehicleType] = React.useState("");
  
  let history = useHistory();

  const initialValues = {
    Vehiclename: "",
    year: "",
    file: null,
    subType:""
  };
  const onFormSubmit = async (values) => {
    let formData = new FormData();
    formData.append("name", values.Vehiclename);
    formData.append("file", values.file);
    formData.append("year", values.year);
    formData.append("manufacturer_id", selectedManufacturer);
    formData.append("type_id", selectedVehicleType);
    formData.append("sub_type", values.subType);
    submitVehicle(formData);
    setSelectedManufacturer("");
    setSelectedVehicleType("");
    values.Vehiclename = "";
    values.year = "";
    values.file = null;
    values.subType = "";
  };
  const validateVehicleForm = yup.object().shape({
    Vehiclename: yup
      .string()
      .required("Vehicle model name is required")
      .matches(
        /[a-zA-Z0-9]+$/,
        "Only alphabets and number are allowed for this field "
      )
      .trim("Manufacturer cannot contain extra spaces")
      .strict(true),

    year: yup
      .string()
      .min(4, "Too Short!")
      .max(4, "Too Long!")
      .required("vehicle model year required")
      .matches(/^[0-9\b]+$/, "Only number are allowed for this field "),

    file: yup
      .mixed()
      .required("upload image in only jpeg/jpg/png format")
      .test(
        "FILE_SIZE",
        "Image size should be less than 1 MB",
        (value) => !value || (value && value.size <= 1024 * 1024)
      ),
  });

  const columns = [
    {
      field: "name",
      headerName: "Name of Vehicle Model",
    },

    {
      field: "price",
      headerName: "Action",
      valueGetter: (v, d) => {
        

        return (
          <>
            {
              <>
                <EditOutlinedIcon
                  onClick={() => {
                    onClickEdit(d.id, d.name, d.year, d.manufacturer_id,d.thumbnail);
                  }}
                  sx={{
                    cursor: "pointer",
                    color: "#004AAD",
                    marginLeft: "36%",
                  }}
                />

                {
                  <Switch
                    checked={d.status === 1 ? true : false}
                    onClick={() => handleStatusVehicle(d.id, d.status)}
                    sx={{ marginBottom: "20px" }}
                  />
                }
              </>
            }
          </>
        );
      },
    },
  ];
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(formData,{ resetForm }) => {
          onFormSubmit(formData).then(() => {
            resetForm(); 
            document.getElementById("file").value = ""; 
          });
        }}
        validationSchema={validateVehicleForm}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isValid,
          values,
          touched,
          errors,
        }) => (
          <>
            <Text
              variant="h5"
              color="#202020"
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "40px",
              }}
            >
              <ArrowBackIcon
                sx={{
                  fontSize: "22px",
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
                onClick={() => history.goBack()}
              />
              Add Vehicle Model
            </Text>

            <Grid
              container
              item
              sx={12}
              direction={{ sm: "column", xs: "column", md: "row" }}
            >
   <Grid item xs={4}>
<Text sx={{ color: "#666666", fontSize: "14px" }}>
              Select Vehicle Manufacturer
            </Text>
            <Select
              sx={{ width: "300px", marginBottom: "15px" }}
              size="small"
              value={selectedManufacturer}
              onChange={(car) => {
                setSelectedManufacturer(car.target.value);
                handleOnChnageVehicle(car.target.value);
              }}
            >
              {selectlist?.map((item) => (
                <MenuItem sx={{ fontSize: "14px" }} key={item} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
   </Grid>
   <Grid item xs={4}>
            <Text sx={{ color: "#666666", fontSize: "14px" }}>
              Select Vehicle Type
            </Text>
            <Select
              sx={{ width: "300px", marginBottom: "15px" }}
              size="small"
              value={selectedVehicleType}
              onChange={(car) => {
                setSelectedVehicleType(car.target.value);
                // handleOnChnageVehicle(car.target.value);
              }}
            >
              {vehicleModelType?.map((item) => (
                <MenuItem sx={{ fontSize: "14px" }} key={item} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
   </Grid>
   <Grid item xs={4}>
            <Text sx={{ color: "#666666", fontSize: "14px" }}>
              Enter Vehicle SubType
            </Text>
            <Box sx={{ width: "300px" }}>
                  <TextField
                    size="small"
                    onChange={handleChange("subType")}
                    onBlur={handleBlur("subType")}
                    value={values.subType}
                    error={!touched.subType && Boolean(errors.subType)}
                    onInput={(e) => {
                      e.target.value = e.target.value.trimStart();
                    }}
                  />

                  {errors.subType && (
                    <Typography sx={{ color: "red" }}>
                      {errors.subType}
                    </Typography>
                  )}
                </Box>
   </Grid>

              <Grid item xs={4}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Enter Vehicle Model Name
                </Text>
                <Box sx={{ width: "300px" }}>
                  <TextField
                    size="small"
                    onChange={handleChange("Vehiclename")}
                    onBlur={handleBlur("Vehiclename")}
                    value={values.Vehiclename}
                    error={!touched.Vehiclename && Boolean(errors.Vehiclename)}
                    onInput={(e) => {
                      e.target.value = e.target.value.trimStart();
                    }}
                  />

                  {errors.Vehiclename && (
                    <Typography sx={{ color: "red" }}>
                      {errors.Vehiclename}
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Enter Vehicle Model Year
                </Text>
                <Box sx={{ width: "300px" }}>
                  <TextField
                    size="small"
                    onChange={handleChange("year")}
                    onBlur={handleBlur("year")}
                    value={values.year}
                    inputProps={{ maxlength: 4 }}
                    error={!touched.year && Boolean(errors.year)}
                    onInput={(e) => {
                      e.target.value = e.target.value.trim();
                    }}

                  />

                  {errors.year && (
                    <Typography sx={{ color: "red" }}>{errors.year}</Typography>
                  )}
                </Box>

              </Grid>

              <Grid item xs={4}>
                <Text sx={{ color: "#666666", fontSize: "14px" }}>
                  Add Vehicle Image
                </Text>
                <Box sx={{ width: "300px" }}>
                  <Box
                    sx={{
                      width: "300px",
                      height: "25px",
                      border: "1px solid rgba(0, 0, 0, 0.27)",
                      padding: "10px 10px",
                      borderRadius: "5px",
                    }}
                  >
                    <input
                      id="file"
                      name="photo"
                      type="file"
                      accept="image/*"
                      className="form-control"
                      onChange={(event) => {
                        setFieldValue("file", event.currentTarget.files[0]);
                      }}
                      error={!touched.file && Boolean(errors.file)}
                    />
                  </Box>

                  {errors.file && (
                    <Typography sx={{ color: "red" }}>{errors.file}</Typography>
                  )}
                </Box>

              </Grid>
            </Grid>
            <Stack mt={5}>
              <Button
                variant="contained"
                sx={{ width: "114.17px", height: "54px", fontSize: "16px" }}
                onClick={() => handleSubmit()}
                disabled={
                  !isValid ||
                  !values.Vehiclename ||
                  !values.year ||
                  !selectedManufacturer
                }
              >
                save
              </Button>
              <br></br>

              <CTable
                columns={columns}
                data={data}
                isLoading={loading?.isLoading}
                pagination={true}
                localPagination={true}
                page={0}
                rowsPerPage={5}
              ></CTable>
            </Stack>
          </>
        )}
      </Formik>
    </>
  );
};

export default AddVehicleModel;
